<template>
	<div class="AdminLayout">
		<header class="Header">
			<div class="Header-left">
				<a class="Header-logo" href="/">
					<img src="/map/dist/skin/logo.svg" alt="Logo" />
				</a>
				<span v-if="isLoading" style="color: #777; font-size: 13px; position: absolute;">
					<LoadingIndicator style="height: 16px;"/>
					Bezig met laden...
				</span>
			</div>
			<div class="Header-right">
        <Button v-if="allowedTo(['dashboard', 'dashboard/uitvoerdersploeg'])"
                @click="$router.push({name: 'dashboard'})">Dashboard</Button>
				<Button v-if="allowedTo(['map', 'map/planning', 'map/marketing', 'map/appointments',
				'map/uitvoering'])" @click="$router.push({name: 'map'})">Map</Button>
				<Button @click="doLogout">Uitloggen</Button>
			</div>
		</header>
		<main class="AdminLayout-main" style="display: flex; flex-direction: row; z-index: 0; position: relative;">
			<aside class="AdminLayout-sidebar" style="height: calc(100vh - 44px); width: 200px; background: #fff; box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);">
				<Button @click="$router.push('/admin')">
					<template v-slot:icon><GridIcon size="1.5x" /></template>
					Dashboard
				</Button>
				<Button v-if="allowedTo('admin/users')" @click="$router.push('/admin/users')">
					<template v-slot:icon><UsersIcon size="1.5x" /></template>
					Gebruikers
				</Button>
				<Button v-if="allowedTo('admin/geo')" @click="$router.push('/admin/geo')">
					<template v-slot:icon><RefreshCwIcon size="1.5x" /></template>
					GeoLocaties
				</Button>
				<Button v-if="allowedTo('admin/sync')" @click="$router.push('/admin/sync')">
					<template v-slot:icon><RefreshCwIcon size="1.5x" /></template>
					DataSync
				</Button>
        <Button v-if="allowedTo('admin/colors')" @click="$router.push('/admin/colors')">
					<template v-slot:icon><Edit2Icon size="1.5x" /></template>
					Kleuren
				</Button>
			</aside>
			<div class="AdminLayout-content" style="height: calc(100vh - 44px); overflow: auto; flex-grow: 1; background: #eee;">
				<div v-if="isLoading" style="z-index: 2;position: absolute; top: 0; left: 0; bottom: 0; right: 0; background: rgba(238, 238, 238, 0.4);">
					<LoadingIndicator style="position: absolute; top: 50%; left: 50%; transform: translateX(-50%)
					translateY(-50%);" />
				</div>
				<transition name="fade">
					<router-view />
				</transition>
			</div>
		</main>
	</div>
</template>

<script>
	import { mapState, mapActions, mapMutations, mapGetters } from 'vuex';
	import Button from '@/components/Button';
	import LoadingIndicator from '@/components/LoadingIndicator';
  import { GridIcon, UsersIcon, RefreshCwIcon, Edit2Icon } from "vue-feather-icons";

	export default {
		components: {
			Button,
			LoadingIndicator,
			UsersIcon,
			GridIcon,
			RefreshCwIcon,
      Edit2Icon
		},

		computed: {
			...mapState({
				isLoading: 'loading',
			}),
			...mapGetters({
				allowedTo: 'auth/allowedTo',
			}),
		},

		methods: {
			...mapActions({
				logoutUser: 'auth/logoutUser',
			}),

			doLogout() {
				this.logoutUser();
				this.$router.push({ name: 'login' }).catch((error) => { if (error) console.error(error) });
			},
		}
	};
</script>
